import UseCase from "core/useCase/UseCase";
import { FeatureFlag } from "domain/entity/FeatureFlag";
import { IFeatureFlagRepository } from "domain/repository/IFeatureFlagRepository";

export default class GetFeatureFlagUseCase extends UseCase<
  FeatureFlag,
  string
> {
  private repository: IFeatureFlagRepository;

  constructor(repository: IFeatureFlagRepository) {
    super();
    this.repository = repository;
  }

  execute = (key: string) => this.repository.getFlag(key);
}
